import { IMeetingCategoryReference } from '@ViewModels';

/**
 * A maximum of 0 or absent means no limit, matching how the API has always read maxPerDay/maxPerMonth.
 */
export const toMeetingCategoryMaxValue = (value: string) => {
	const parsed = parseInt(value, 10);
	return isNaN(parsed) || parsed <= 0 ? undefined : parsed;
};

/**
 * Read-only summary of what a category caps its meetings at, shown beside the per-meeting maximums so the
 * interplay between the two is visible without leaving the modal.
 */
export const buildCategoryLimitHint = (category: IMeetingCategoryReference | null | undefined) => {
	if (!category) {
		return null;
	}

	const limits = [
		(category.maxPerDay ?? 0) > 0 ? `${category.maxPerDay} per day` : null,
		(category.maxPerMonth ?? 0) > 0 ? `${category.maxPerMonth} per month` : null,
	].filter(Boolean);

	if (!limits.length) {
		return null;
	}

	return `Category "${category.name}" caps every meeting in it at ${limits.join(
		' and '
	)} combined. Whichever limit is stricter applies.`;
};
